<template>
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="text-primary-5"
  >
    <path
      d="M0 7.51032L4.3121 10.0001L0 12.4896V16.0884L5.45466 12.9391V7.06083L0 3.91206V7.51032Z"
      fill="currentColor"
    />
    <path
      d="M5.45459 12.939L5.455 19.2372L8.57119 17.4381L8.57131 12.4589L12.8833 14.9485L15.9999 13.1491L10.5453 9.99988L5.45459 12.939Z"
      fill="currentColor"
    />
    <path
      d="M15.9999 6.85071L12.8833 5.05134L8.57131 7.54098L8.57119 2.56172L5.455 0.762589L5.45459 7.06083L10.5453 9.99995L15.9999 6.85071Z"
      fill="currentColor"
    />
  </svg>
</template>
